/* ===== safe closest/matches for Element, SVG and Text nodes ===== */
export default function initPolyfills(){
  (function(){
    const EP = window.Element && Element.prototype;
    const SP = window.SVGElement && SVGElement.prototype;

    // ---- matches
    const nativeMatches =
        (EP && (EP.matches || EP.msMatchesSelector || EP.webkitMatchesSelector)) || null;

    function matchesShim(sel){
      // бросаем ту же ошибку, что и нативный, если селектор некорректен
      const doc = this.ownerDocument || document;
      const list = doc.querySelectorAll(sel);
      let i = list.length;
      while (--i >= 0 && list.item(i) !== this) {}
      return i > -1;
    }

    if (EP && !EP.matches) EP.matches = nativeMatches || matchesShim;
    if (SP && !SP.matches) SP.matches = (SP.msMatchesSelector || SP.webkitMatchesSelector || matchesShim);

    // ---- closest (только вверх по parentNode; Element/SVG безопасно)
    function closestShim(sel){
      let el = this;
      // если это не элемент (например, текст) — поднимемся к родителю
      if (!el || el.nodeType !== 1) el = el && el.parentNode;
      while (el && el.nodeType === 1) {
        if (el.matches && el.matches(sel)) return el;
        el = el.parentNode; // важнО: не parentElement — для SVG может быть null
      }
      return null;
    }

    if (EP && !EP.closest) EP.closest = closestShim;
    if (SP && !SP.closest) SP.closest = closestShim;

    // (необязательно) НЕ стандарт, но удобно для текст-узлов:
    if (!Node.prototype.closest) {
      Object.defineProperty(Node.prototype, 'closest', {
        value: closestShim,
        configurable: true,
        writable: true
      });
    }
  })();
}
